/**
 * Channels Services - Re-exports from Module
 * 
 * This file re-exports all channels-related types and hooks from the
 * centralized module at src/modules/channels.
 * 
 * @deprecated Import directly from '@modules/channels' for new code
 */

// ============================================
// Types Re-exports
// ============================================

// Enums
export { ChannelType } from '../modules/channels/types';
export type {
  ChannelName,
  ChannelStatus,
  ChannelConnectionStatus,
  ConnectionStep,
  UnitMappingStatus,
  UnitStatus,
  BookingUnitType,
} from '../modules/channels/types';

// API Types
export type {
  IApiResponse,
  IApiChannel,
  IApiConnectedAccount,
  IGetChannelsResult,
  IApiListing,
  IGetListingsResult,
  IChannelUnitsForImportResult,
  IChannelUnitForImport,
  IImportListingsRequest,
  IImportListingResult,
  IImportListingsResponse,
  IConnectAirbnbResponse,
  ICheckBookingConnectionRequest,
  ICheckBookingConnectionResponse,
  IValidateBookingHotelIdsRequest,
  IHotelValidationResult,
  IValidateBookingHotelIdsResponse,
  IGathernRequestOTPRequest,
  IGathernSendOTPApiResponse,
  IGathernRequestOTPResponse,
  IGathernVerifyOTPRequest,
  IGathernVerifyOTPApiResponse,
  IGathernVerifyOTPResponse,
  IUpdateListingStatusRequest,
  IUpdateListingStatusResponse,
  IApiChannelUnit,
  IGetAirbnbUnitsResult,
  IGetBookingUnitsResult,
  IGetGathernUnitsResult,
  IConnectChannelRequest,
  IConnectChannelResponse,
} from '../modules/channels/types';

// Channel Entity Types
export type {
  IAvailableAction,
  IGetChannelsResponse,
  IChannelProperty,
  IImportStatus,
} from '../modules/channels/types';

// ============================================
// Services/Hooks Re-exports
// ============================================

// Query hooks - import for local use, then re-export
import {
  useChannelsQuery as _useChannelsQuery,
  useChannelByTypeQuery as _useChannelByTypeQuery,
  useChannelQuery as _useChannelQuery,
  useChannelUnitsForImportQuery as _useChannelUnitsForImportQuery,
  useGetAirbnbUnitsQuery as _useGetAirbnbUnitsQuery,
  useGetBookingUnitsQuery as _useGetBookingUnitsQuery,
  useGetGathernUnitsQuery as _useGetGathernUnitsQuery,
  mapChannelTypeToName as _mapChannelTypeToName,
  mapChannelNameToType as _mapChannelNameToType,
  useConnectAirbnbMutation as _useConnectAirbnbMutation,
  useGathernRequestOTPMutation as _useGathernRequestOTPMutation,
  useGathernVerifyOTPMutation as _useGathernVerifyOTPMutation,
  useCheckBookingConnectionMutation as _useCheckBookingConnectionMutation,
  useValidateBookingHotelIdsMutation as _useValidateBookingHotelIdsMutation,
  useImportUnitsMutation as _useImportUnitsMutation,
  useUpdateListingStatusMutation as _useUpdateListingStatusMutation,
  useConnectChannelMutation as _useConnectChannelMutation,
} from '../modules/channels/services';

// Re-export all hooks
export const useChannelsQuery = _useChannelsQuery;
export const useChannelByTypeQuery = _useChannelByTypeQuery;
export const useChannelQuery = _useChannelQuery;
export const useChannelUnitsForImportQuery = _useChannelUnitsForImportQuery;
export const useGetAirbnbUnitsQuery = _useGetAirbnbUnitsQuery;
export const useGetBookingUnitsQuery = _useGetBookingUnitsQuery;
export const useGetGathernUnitsQuery = _useGetGathernUnitsQuery;
export const mapChannelTypeToName = _mapChannelTypeToName;
export const mapChannelNameToType = _mapChannelNameToType;
export const useConnectAirbnbMutation = _useConnectAirbnbMutation;
export const useGathernRequestOTPMutation = _useGathernRequestOTPMutation;
export const useGathernVerifyOTPMutation = _useGathernVerifyOTPMutation;
export const useCheckBookingConnectionMutation = _useCheckBookingConnectionMutation;
export const useValidateBookingHotelIdsMutation = _useValidateBookingHotelIdsMutation;
export const useImportUnitsMutation = _useImportUnitsMutation;
export const useUpdateListingStatusMutation = _useUpdateListingStatusMutation;
export const useConnectChannelMutation = _useConnectChannelMutation;

// ============================================
// Legacy useChannels Hook (for backward compatibility)
// ============================================

/**
 * @deprecated Use individual hooks directly instead:
 * - useChannelsQuery()
 * - useChannelByTypeQuery()
 * - useConnectAirbnbMutation()
 * etc.
 */
export const useChannels = () => {
  return {
    // Queries
    useChannelsQuery,
    useChannelQuery: useChannelByTypeQuery,
    useChannelUnitsForImportQuery,
    useGetAirbnbUnitsQuery,
    useGetBookingUnitsQuery,
    useGetGathernUnitsQuery,
    // Mutations
    useConnectChannelMutation,
    useImportUnitsMutation,
    useConnectAirbnbMutation,
    useGathernRequestOTPMutation,
    useGathernVerifyOTPMutation,
    useCheckBookingConnectionMutation,
    useValidateBookingHotelIdsMutation,
    useUpdateListingStatusMutation,
  };
};

export default useChannels;
